<app-painel-lateral [tituloPainel]="'Qualidade de Dados e Monitoramento'" [descricaoPainel]="'Completude cadastral e radar de prazos por UF.'" [iconePainel]="'pi pi-shield'" [filtrosTemplate]="filtros" [conteudoTemplate]="conteudo">
</app-painel-lateral>

<ng-template #filtros>
    <app-mapa-uf-card [uf]="ufSelecionada" (ufChange)="onUfSelecionadaChange($event)"></app-mapa-uf-card>
    <label class="mapa-filtro">
        <span class="mapa-filtro-label">UF do estado</span>
        <app-estado-select [uf]="ufSelecionada ?? 'BR'" [ufsPermitidas]="ufsPermitidas" (ufChange)="onUfSelecionadaChange($event)"></app-estado-select>
    </label>
    <p-button label="Aplicar" icon="pi pi-search" (onClick)="aplicar()"></p-button>
</ng-template>

<ng-template #conteudo>
    <div class="qualidade-secoes">
        <!-- Seção 1: Completude cadastral -->
        <div class="card-entrada card-entrada-1">
            <app-card-content [border]="false" [title]="'Completude cadastral'" icon="pi pi-check-circle">
                <p-table [value]="completude" [loading]="carregandoCompletude" styleClass="p-datatable-sm w-full" stripedRows>
                    <ng-template pTemplate="header">
                        <tr>
                            <th>UF</th>
                            <th class="num">Total médicos</th>
                            <th class="num">Com pendência</th>
                            <th class="num">Score</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-l>
                        <tr>
                            <td>{{ l.ufSgUf }}</td>
                            <td class="num">{{ l.totalMedicos | number }}</td>
                            <td class="num">{{ l.totalComPendencia | number }}</td>
                            <td class="num">
                                <span class="score-badge" [ngClass]="corScore(l.score)">{{ l.score | number: '1.0-1' }}</span>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="footer">
                        @if (completude.length) {
                            <tr class="linha-total">
                                <td>Total (BR)</td>
                                <td class="num">{{ totaisCompletude.totalMedicos | number }}</td>
                                <td class="num">{{ totaisCompletude.totalComPendencia | number }}</td>
                                <td class="num">
                                    <span class="score-badge" [ngClass]="corScore(totaisCompletude.score)">{{ totaisCompletude.score | number: '1.0-1' }}</span>
                                </td>
                            </tr>
                        }
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="4">Sem dados para os filtros selecionados.</td>
                        </tr>
                    </ng-template>
                </p-table>

                @if (completude.length > 1) {
                    <div class="ranking">
                        <span class="ranking-titulo">Ranking de score por UF</span>
                        @for (l of completudeOrdenada; track l.ufSgUf) {
                            <div class="ranking-linha">
                                <span class="ranking-uf">{{ l.ufSgUf }}</span>
                                <div class="ranking-barra-fundo">
                                    <div class="ranking-barra" [ngClass]="corScore(l.score)" [style.width]="larguraBarra(l.score)"></div>
                                </div>
                                <span class="ranking-valor">{{ l.score | number: '1.0-1' }}</span>
                            </div>
                        }
                    </div>
                }
            </app-card-content>
        </div>

        <!-- Seção 2: Radar de prazos -->
        <div class="card-entrada card-entrada-1">
            <app-card-content [border]="false" [title]="'Radar de prazos'" icon="pi pi-clock">
                <p-table [value]="radar" [loading]="carregandoRadar" styleClass="p-datatable-sm w-full" stripedRows>
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Fonte</th>
                            <th class="num">Vencido</th>
                            <th class="num">≤ 30d</th>
                            <th class="num">≤ 60d</th>
                            <th class="num">≤ 90d</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-l>
                        <tr>
                            <td>{{ l.descricaoFonte || l.fonte }}</td>
                            <td class="num vencido">{{ l.vencido | number }}</td>
                            <td class="num">{{ l.vence30 | number }}</td>
                            <td class="num">{{ l.vence60 | number }}</td>
                            <td class="num">{{ l.vence90 | number }}</td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="footer">
                        @if (radar.length) {
                            <tr class="linha-total">
                                <td>Total</td>
                                <td class="num vencido">{{ totaisRadar.vencido | number }}</td>
                                <td class="num">{{ totaisRadar.vence30 | number }}</td>
                                <td class="num">{{ totaisRadar.vence60 | number }}</td>
                                <td class="num">{{ totaisRadar.vence90 | number }}</td>
                            </tr>
                        }
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="5">Sem dados para os filtros selecionados.</td>
                        </tr>
                    </ng-template>
                </p-table>
            </app-card-content>
        </div>

        <!-- Seção 3: Histórico de pendências (snapshot) — desabilitada até a tabela USR_SICOM.GESTAO_PENDENCIA_SNAPSHOT existir no banco (flag snapshotHabilitado) -->
        @if (snapshotHabilitado) {
            <div class="card-entrada card-entrada-1">
                <app-card-content [border]="false" [title]="'Histórico de pendências (snapshot)'" icon="pi pi-history">
                    <div class="historico-controles">
                        <label class="mapa-filtro historico-indicador">
                            <span class="mapa-filtro-label">Indicador</span>
                            <p-select [options]="indicadores" [(ngModel)]="indicadorSelecionado" optionLabel="label" optionValue="value" appendTo="body" (onChange)="onIndicadorChange()"></p-select>
                        </label>
                        <p-button label="Capturar snapshot agora" icon="pi pi-camera" [loading]="capturando" (onClick)="capturarSnapshot()"></p-button>
                    </div>

                    @if (carregandoHistorico) {
                        <div class="historico-status">Carregando série histórica…</div>
                    } @else if (dadosGrafico) {
                        <div class="historico-grafico">
                            <p-chart type="line" [data]="dadosGrafico" [options]="opcoesGrafico"></p-chart>
                        </div>
                    } @else {
                        <div class="historico-vazio">
                            <i class="pi pi-info-circle"></i>
                            <div>
                                <p>Nenhum snapshot registrado. A série passa a acumular a partir da primeira captura.</p>
                                <p class="historico-nota">Observação: a tabela <code>GESTAO_PENDENCIA_SNAPSHOT</code> precisa existir no banco para que as capturas sejam persistidas.</p>
                            </div>
                        </div>
                    }
                </app-card-content>
            </div>
        }
    </div>
</ng-template>
